module.exports = __webpack_public_path__ + "static/img/fany-single.029d723.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fany-single.webp
// module id = 209
// module chunks = 0